// noop: didn't do anything in MW except some type safety
export function asFrontendKey<T>(x: T): T {
  return x
}

// noop: didn't do anything in MW except some type safety
export function fromFrontendKey<T>(x: T): T {
  return x
}
